import { Box } from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/colors";

interface Props {
  onClick: () => unknown;
  isClicked: boolean;
}
export const DropdownAnchor = ({ onClick, isClicked }: Props) => {
  return (
    <Box
      style={{
        transform: isClicked ? "rotate(180deg)" : "rotate(0deg)",
        cursor: "pointer",
        transition: "transform 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.59 0.589996L6 5.17L1.41 0.589996L0 2L6 8L12 2L10.59 0.589996Z"
          fill={Colors.AshRose}
        />
      </svg>
    </Box>
  );
};
